export default "__VITE_ASSET__tjTRCKqG__"